<template>
    <div class="layout">
      <el-container>
        <el-aside width="222px" class="menuStyle">
          <div class="userinfo_style">
            <img src="@/assets/image/logo.png" alt="" />
            <div>筑盾</div>
          </div>
          <el-menu
            class="menu"
            background-color="#5079f1"
            text-color="#fff"
            active-text-color="#5079F1"
            :router="true"
            :default-active="activeMenu"
            :collapse="isCollapse"
          >
            <template v-for="menu in menus">
              <!-- v-show="allowPages.includes(menu.page) || menu.is_public" -->
              <el-submenu
                v-if="menu.children"
                :key="'submenu-' + menu.path"
                :index="menu.path"
              >
                <template slot="title">
                  <i :class="menu.icon" style="margin-right: 9px"></i>
                  <span slot="title">{{ menu.name }}</span>
                </template>
                <el-menu-item
                  v-for="child in menu.children"
                  :key="child.path"
                  :index="child.path"
                  @click="handleMenu(child)"
                >
                  <!-- v-show="allowPages.includes(child.page) || menu.is_public" -->
  
                  <i :class="child.icon" style="margin-right: 9px"></i>
                  <span>·{{ child.name }}</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :key="'menu-' + menu.path" :index="menu.path" @click="handleMenu(menu)">
                <!-- v-show="allowPages.includes(menu.page) || menu.is_public" -->
  
                <i :class="menu.icon" style="margin-right: 9px"></i>
                <span slot="title">{{ menu.name }}</span>
              </el-menu-item>
            </template>
  
            <!-- <el-menu-item :index="item.path" v-for="(item,index) in menuList" :key="index">
              <i class="el-icon-setting"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item> -->
          </el-menu>
        </el-aside>
        <el-container class="main-container">
          <el-header height="88px">
            <el-dropdown style="float: right;" placement="bottom-start">
              <div class="header">
                  <img :src="userInfo.avatar" alt="" />
                  <div>{{userInfo.name}}</div>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div @click.stop="$router.push('/personalCenter')">个人中心</div>
                  </el-dropdown-item>
                  <el-dropdown-item @click="handleLogout">
                    <div @click.stop="handleLogout">退出登录</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            
          </el-header>
          <el-main>
            <!-- <router-view /> -->
            <router-view></router-view>
            <!-- <div style="height: 60px"></div> -->
          </el-main>
        </el-container>
      </el-container>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  export default {
    name: "Layout",
    data() {
      return {
        menus: [
          { id: 1, name: "首页", path: "/home", icon: "iconfont icon-shouye" },
          {
            id: 2,
            name: "项目看板",
            path: "/bulletinBoard",
            icon: "iconfont icon-xiangmukanban2",
          },
          {
            id: 3,
            name: "项目管理",
            path: "/projectManagement",
            icon: "iconfont icon-xiangmuguanli",
            children: [
              { id: "3-1", name: "项目列表", path: "/projectList" },
              { id: "3-2", name: "项目日志管理", path: "/projectLog" },
              { id: "3-3", name: "我的日志列表", path: "/myLog" },
              { id: "3-4", name: "成员管理", path: "/projectMemberList" },
            ],
          },
          {
            id: 4,
            name: "进度任务管理",
            icon: "iconfont icon-daiban",
            path: "/progressTasks",
            children: [
              { id: "4-1", name: "进度任务列表", path: "/progressTaskList" },
              { id: "4-2", name: "我的进度列表", path: "/myProgress" },
            ],
          },
          {
            id: 5,
            name: "事件任务管理",
            path: "/eventTaskList",
            icon: "iconfont icon-xiangmuguanli",
          },
          {
            id: 6,
            name: "协作事项管理",
            path: "/collaborativeProjectManagement",
            icon: "iconfont icon-renyuankuguanli",
            children: [
            //   { id: "6-1", name: "审核管理列表", path: "/reviewList" },
              { id: "6-2", name: "支款申请列表", path: "/withdrawalList" },
              { id: "6-3", name: "用章申请列表", path: "/chapterList" },
              { id: "6-4", name: "请假申请列表", path: "/leaveList" },
              { id: "6-5", name: "其他申请列表", path: "/otherList" },
              { id: "6-6", name: "报销申请列表", path: "/reimbursementList" },
              { id: "6-7", name: "我的提交记录", path: "/myApplyLog" },
            ],
          },
          {
            id: 7,
            name: "考勤管理",
            path: "/attendance",
            icon: "iconfont icon-kaoqin",
            children: [
              {
                id: "7-1",
                name: "考勤设置",
                path: "/attendanceSetting",
              },
              { id: "7-2", name: "考勤记录", path: "/attendanceRecord" },
            ],
          },
          {
            id: 8,
            name: "补卡管理",
            path: "/cardReplacementManagement",
            icon: "iconfont icon-buqia",
            children: [
              {
                id: "8-1",
                name: "补卡申请",
                path: "/cardReplacementApply",
              },
              { id: "8-2", name: "补卡列表", path: "/cardReplacementList" },
              { id: "8-3", name: "补卡设置", path: "/cardReplacementSettings" },
            ],
          },
          {
            id: 9,
            name: "库存管理",
            path: "/inventoryManagement",
            icon: "iconfont icon-kucun",
            children: [
              { id: "9-1", name: "库存列表", path: "/inventoryList" },
              { id: "9-2", name: "库存记录", path: "/inventoryRecords" },
              { id: "9-3", name: "领用申请", path: "/requisitionList" },
              { id: "9-4", name: "归还申请", path: "/returnList" },
              { id: "9-5", name: "单位列表", path: "/unitList" },
            ],
          },
          {
            id: 10,
            name: "法律援助",
            icon: "iconfont icon-menu_flyz",
          },
          {
            id: 11,
            name: "消息",
            path: "/message",
            icon: "iconfont icon-xiaoxi",
            children: [
              { id: "11-1", name: "平台消息", path: "/platformMessages" },
              { id: "11-2", name: "项目公告", path: "/projectAnnouncement" },
              { id: "11-3", name: "新闻动态", path: "/newsMessage" },
              { id: "11-4", name: "通讯录", path: "/addressBook" },
            ],
          },
          {
            id: 12,
            name: "我的",
            path: "/my",
            icon: "iconfont icon-wodedangxuan",
            children: [
              { id: "12-1", name: "客服中心" },
              { id: "12-2", name: "意见反馈", path: "/feedback" },
              { id: "12-3", name: "联系我们", path: "/contactUs" },
              { id: "12-4", name: "操作说明", path: "/instructionManual" },
            ],
          },
        ],
        activeMenu: this.$route.path,
        isCollapse: false,
      };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    methods: {
        handleMenu(menu) {
            if(menu.id == 10 || menu.id === '12-1'){
              let url = `https://api.zhudunm.com/chatlink.html?eid=00d5d8c7f320272c74c780ee6b7d06ff&clientid=${this.userInfo.id}${menu.id == 10?'00000':'11111'}&groupid=${menu.id == 10? '8d56168f254f91447ec4a903d1d3a35e':'bfa4cdc61b338608bb9ece82175b3284'}`
              window.open(url);
            }
        },
        handleLogout() {
          this.$store.dispatch('loginOut').then(() => {
            this.$router.push({ path: "/pwdLogin" });
          })
        }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .layout {
    display: flex;
    height: 100vh;
  }
  .menuStyle {
    // width: 222px;
    height: 100vh;
    background-color: #5079f1;
    display: flex;
    flex-direction: column;
    .userinfo_style {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #ffffff;
      margin: 20px 0 40px 20px;
      img {
        width: 52px;
        height: 52px;
        margin-right: 12px;
      }
    }
  }
  .menu {
    width: 90%;
    border-right: none;
    // box-sizing: border-box; /* 使用border-box盒模型，确保内边距和边框不会增加元素的宽度 */
  }
  .el-menu-item {
    // background: none !important; //修改悬停背景色
    border-radius: 6px;
    margin: 0 14px;
    i {
      color: #ffffff;
    }
  }
  .el-menu-item.is-active {
    background-color: #ffffff !important;
    border-radius: 6px;
    margin: 0 14px;
    box-sizing: border-box;
    i {
      color: #5079f1;
    }
  }
  .el-submenu {
    border-radius: 6px;
    margin: 0 14px;
    i {
      color: #ffffff;
    }
    .el-menu-item {
      min-width: 185px;
      margin: 0;
    }
  }
  
  .main-container {
    position: relative;
    z-index: 3;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .header {
    cursor: pointer;
    height: 88px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #5079f1;
    letter-spacing: 0.8px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 60px;
    img {
      width: 28px;
      height: 28px;
      margin-right: 6px;
    }
  }
  ::v-deep .el-header {
    background: #ffffff;
    // background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 3px 6px 0px rgba(183, 183, 183, 0.15);
  }
  // ::v-deep .el-aside {
  //     overflow: visible;
  //     box-sizing: border-box;
  //     flex-shrink: 0;
  // }
  ::v-deep .el-main {
    width: calc(100vw - 222px);
    flex: 1; /* 主体部分占据剩余空间 */
    overflow-y: auto; /* 设置滚动条 */
    padding: 0 !important;
    // position: absolute;
    // z-index: -1;
    // top: 0;
    // right: 0;
    // bottom: 0;
  }
  </style>